import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 690px;
  margin-left: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-left: 0;
    width: 88%;
    margin-left: 20px;
  }
`;

export const ShowLessWrap = styled.div`
  margin-top: 10px;
  button {
    margin: 0 0 20px 0;
  }
`;

export const ShowLessWrapMargin = styled(ShowLessWrap)`
  margin-top: 34px;
`;

export const ImageWrap = styled.img`
  width: 8px;
  height: 4px;
  color: #006778;
  margin-left: 6px;
`;

export const ContinueWrap = styled.div`
  margin-top: -24px;
`;
